module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_5010.5c7d8854.png";